import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
// import Pedidos from "./pages/Pedidos";
import Carrinho from "./pages/Carrinho";
import Login from "./pages/Login";
import ListarRestaurantes from "./pages/ListarRestaurantes";
import CadastrarProdutos from "./components/CadastrarProdutos";
import EditarRestaurente from "./pages/EditarRestaurente";
import RotinasFuncionario from "./pages/RotinasFuncionario";
import Aproveitamentos from "./pages/Aproveitamentos";
import Producao from "./pages/Producao";
import EditarProdutos from "./pages/EditarProdutos";
import Relatorios from "./pages/Relatorios";
import RelatorioAproveitamento from "./pages/RelatorioAproveitamento";
import RelatorioRotina from "./pages/RelatorioRotina";
import RelatorioProducao from "./pages/RelatorioProducao";
import RelatorioDesperdicio from "./pages/RelatorioDesperdicio";
import RelatorioNotas from "./pages/RelatorioNotas";
import AvaliacaoRestaurante from "./pages/AvaliacaoRestaurante";
import ProtectedRoute from "./route/ProtectedRoute";
import { FiltroProvider } from './context/FiltroContext';
import ListarFornecedores from './pages/ListarFornecedores';
import Notas from './pages/Notas';
import { LoadingProvider, useLoading } from './context/LoadingContext';
import LoadingSpinner from "./components/LoadingSpinner";
import { AvaliacaoProvider } from "./context/AvaliacaoRestauranteContext";
import ListarAvaliacoes from "./pages/ListarAvaliacoes";
import { AdminRestaurantes, AdminUsuarios, AdminVinculos } from "./pages/Admin";

function App() {
  const location = useLocation();
  const { isLoading } = useLoading();

  // Ocultar Header e Footer em telas específicas
  const hideHeaderFooter = ["/login", "/"].includes(location.pathname);

  useEffect(() => {
    if (isLoading) {
      document.body.classList.add('blur-background');
    } else {
      document.body.classList.remove('blur-background');
    }
  }, [isLoading]);

  return (
    <div className="app">
      <LoadingSpinner />
      {!hideHeaderFooter && <Header />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/restaurantes"
          element={
            <ListarRestaurantes />
          }
        />
        <Route
          path="/restaurantes/:id/avaliar"
          element={
            <AvaliacaoRestaurante />
          }
        />
        <Route
          path="/restaurantes/:id/produtos/cadastrar"
          element={
            <ProtectedRoute>
              <CadastrarProdutos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/restaurantes/editar"
          element={
            <ProtectedRoute>
              <EditarRestaurente />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/produtos/editar"
          element={
            <ProtectedRoute>
              <EditarProdutos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/restaurantes/rotinas"
          element={
            <ProtectedRoute>
              <RotinasFuncionario />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/restaurantes/aproveitamentos"
          element={
            <ProtectedRoute>
              <Aproveitamentos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/restaurantes/producao"
          element={
            <ProtectedRoute>
              <Producao />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/relatorios"
          element={
            <ProtectedRoute>
              <Relatorios />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/relatorios/aproveitamento"
          element={
            <ProtectedRoute>
              <RelatorioAproveitamento />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/relatorios/rotina"
          element={
            <ProtectedRoute>
              <RelatorioRotina />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/relatorios/producao"
          element={
            <ProtectedRoute>
              <RelatorioProducao />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/relatorios/desperdicio"
          element={
            <ProtectedRoute>
              <RelatorioDesperdicio />
            </ProtectedRoute>
          }
        />
        <Route path="/:id/cardapio" element={<Home />} />
        <Route path="/carrinho" element={<Carrinho />} />
        <Route
          path="/restaurantes/:id/fornecedores"
          element={
            <ProtectedRoute>
              <ListarFornecedores />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/notas"
          element={
            <ProtectedRoute>
              <Notas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/restaurantes/:id/relatorios/notas"
          element={
            <ProtectedRoute>
              <RelatorioNotas />
            </ProtectedRoute>
          }
        />
        <Route path="/restaurantes/:id/avaliacoes" element={<ListarAvaliacoes />} />
        <Route path="/admin/restaurantes" element={<ProtectedRoute><AdminRestaurantes /></ProtectedRoute>} />
        <Route path="/admin/usuarios" element={<ProtectedRoute><AdminUsuarios /></ProtectedRoute>} />
        <Route path="/admin/vinculos" element={<ProtectedRoute><AdminVinculos /></ProtectedRoute>} />
      </Routes>
      {!hideHeaderFooter && <Footer />}
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <FiltroProvider>
        <LoadingProvider>
          <AvaliacaoProvider>
            <App />
          </AvaliacaoProvider>
        </LoadingProvider>
      </FiltroProvider>
    </Router>
  );
}

export default AppWrapper;